import { ReactElement } from 'react'
import Layout from '../../components/layout'
import ShopDetails from '../../components/Shops/Details'

const ShopDetailsPage = (): ReactElement => {
  return (
    <Layout >
      <ShopDetails />
    </Layout>
  )
}

export default ShopDetailsPage
